<template>

    <div class="priceTotalHolder">
        <div v-if="reservation.billing" class="w-100">
            <div class="col-sm-12 bg-lighter py-2 border-bottom-light">

                <!-- TICKET PRICE -->
                <div class="darkest fs-small d-flex justify-content-between">
                    <span>Ticket Price</span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.totalProductGrossprice)}} €</span>
                </div>

                <!-- EXTRAS -->
                <div class="darkest fs-small d-flex justify-content-between">
                    <span>Extras</span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else class="w-25 text-right">{{formatPrice(getReservationCalculations.totalComponentGrossprice)}} €</span>
                </div>

                <!-- DISCOUNT -->
                <div v-if="!reservation.attachPromocode && reservation.attachDiscount" class="darkest fs-small d-flex justify-content-between align-items-center align-items-center border-bottom-light mb-1 pb-1">
                    <span class="d-flex align-items-center" >Discount

                        <span class="px-1" v-if="!editingDiscount">{{reservation.attachDiscount.value}}{{(reservation.attachDiscount.valueType == 1)? '%' : '€'}}</span>

                        <span class="d-flex px-1" v-if="editingDiscount">
                            <input :disabled="disabled" type="number" class="glued-right px-2 py-0 text-center border-medium" style="width: 50px;" v-model="reservation.attachDiscount.value" placeholder="0" @focus="discountInputFocus">
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchDiscountType" v-if="reservation.attachDiscount.valueType == 1">%</div>
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchDiscountType" v-if="reservation.attachDiscount.valueType == 0">€</div>
                        </span>

                        <button :disabled="disabled" class="btn secondary tiny mr-1" v-if="editingDiscount" @click="applyingCustomDiscount">Apply</button>
                        <button :disabled="disabled" class="btn secondary tiny ml-1" v-if="(!isReservationReadOnly || reservation.status == 5) && !reservation.flags.isFullyInvoiced" @click="editingDiscountToogle">{{ (editingDiscount) ? 'Remove' : 'EDIT' }}</button>
                    </span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.totalDiscounts)}} €</span>
                </div>

                <!-- Cost -->
                <div class="darkest fs-small d-flex justify-content-between border-bottom-light mb-1 pb-1">
                    <span>Cost</span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else class="w-25 text-right">{{formatPrice(cost)}} €</span>
                </div>

                <!-- PAID -->
                <div class="darkest fs-small d-flex justify-content-between">
                    <span>Paid</span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else class="w-25 text-right">{{formatPrice(this.reservationTotalPaid)}} €</span>
                </div>

                <!-- REFUNDS -->
                <div class="darkest fs-small d-flex justify-content-between border-bottom-light pb-1 mb-1">
                    <span>Refunds</span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <div v-else>
                        <span v-if="pendingRefund" class="w-25 text-right mr-2 dark" v-tooltip="'Pending'">
                            <i class="fas fa-hourglass-half mr-1 dark fs-small"></i>-{{formatPrice(pendingRefund)}} €
                        </span>
                        <span class="w-25 text-right">{{formatPrice(refunds - pendingRefund)}} €</span>
                    </div>
                </div>

                <!-- Total -->
                <div class="darkest fs-large d-flex justify-content-between border-bottom-light mb-1 pb-1">
                    <span class="bold">Total</span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <div v-else>
                        <span v-if="pendingRefund" class="w-25 text-right mr-2 dark" v-tooltip="'If refund is accepted'">
                            <i class="fas fa-hourglass-half mr-1 dark fs-small"></i>{{formatPrice(pendingRefund)}} €
                        </span>
                        <span class="w-25 text-right bold">{{formatPrice(total)}} €</span>
                    </div>
                </div>

                <!-- COMMISSIONS -->
                <div class="darkest fs-small d-flex justify-content-between align-items-center align-items-center">
                    <span class="d-flex align-items-center">
                        <span>Commission (total)</span>
                        <!-- Agent Promocode -->
                        <span v-if="reservation.attachPromocodeType == 1 && reservation.attachDiscount" class="bold ml-2">{{reservation.attachPromocode}}</span>
                        <span v-if="reservation.attachPromocodeType == 1 && reservation.attachDiscount && !getIsLoadingCalculations" class="bold ml-1">({{getReservationCalculations.currentChannelCommission.productValue}}{{(getReservationCalculations.currentChannelCommission.productValueType == 1)? '%' : '€'}})</span>
                        <i class="fas dark ml-2 pointer" :class="{'fa-eye-slash':isCommissionsExpanded, 'fa-eye':!isCommissionsExpanded}" @click="toggleCommissionExpand()"></i>
                    </span>

                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.grandTotalCommission)}} €</span>
                </div>


                <!-- commissions editor -->
                <div class="dark fs-small d-flex justify-content-between align-items-center align-items-center" v-for="commissionType in comissionTypes" v-if="isCommissionsExpanded && commissionType.active">
                    <span class="d-flex align-items-center ml-2">
                        {{commissionType.label + '&nbsp;&nbsp;'}}
                        <span v-if="!isEditingCommissions[commissionType.type.toLowerCase()]">
                            <span style="float:left">{{ reservation.currentChannelCommission[commissionType.type.toLowerCase()+'Value'] }}</span>
                            <span style="float:left" v-if="!reservation.currentChannelCommission || reservation.currentChannelCommission[commissionType.type.toLowerCase()+'ValueType'] == 1">%</span>
                            <span style="float:left" v-if="reservation.currentChannelCommission && reservation.currentChannelCommission[commissionType.type.toLowerCase()+'ValueType'] == 0">€</span>
                        </span>

                        <span class="d-flex px-1 align-items-center" v-if="isEditingCommissions[commissionType.type.toLowerCase()]">
                            <input :disabled="disabled" type="number" class="glued-right px-2 py-0 text-center border-medium" style="width: 50px;" v-model.number="reservation.currentChannelCommission[commissionType.type.toLowerCase()+'Value']" placeholder="0" @input="overrideCommissionChanged($event, commissionType.type)" @focus="commissionInputFocus(commissionType.type)">
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchCommissionType(commissionType.type)" v-if="!reservation.currentChannelCommission || reservation.currentChannelCommission[commissionType.type.toLowerCase()+'ValueType'] == 1">%</div>
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchCommissionType(commissionType.type)" v-if="reservation.currentChannelCommission && reservation.currentChannelCommission[commissionType.type.toLowerCase()+'ValueType'] == 0">€</div>
                            <button :disabled="disabled" class="btn secondary tiny mx-1" v-if="reservation.currentChannelCommission['isToOverwrite'+commissionType.type]" @click="updateCommissions(commissionType)">Apply</button>
                        </span>
                        <span id="hide-use-defaut" v-else><!-- to show "use default" button, remove this surrounding span -->
                            &nbsp;&nbsp;<button :disabled="disabled" class="btn secondary tiny" v-if="commissionType.editable && (!isReservationReadOnly || reservation.status == 5) && !reservation.flags.isFullyInvoiced && (!reservation.attachPromocode && (reservation.attachPromocodeType === 0 || !reservation.attachPromocodeType))" @click="editingCommissionToogle(commissionType.type)">{{ (isEditingCommissions[commissionType.type.toLowerCase()])? 'Use default' : 'EDIT'}}</button>
                        </span>

                    </span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations['total' + commissionType.type + 'CommissionToEntityGrossprice'])}} €</span>
                </div>

                <!-- Tourist Promocode -->
                <div v-if="reservation.attachPromocode && reservation.attachPromocodeType == 0 && reservation.attachDiscount" class="fs-small d-flex justify-content-between align-items-center align-items-center">

                    <span class="d-flex align-items-center" >Promocode:
                        <span v-if="!getIsLoadingCalculations" class="bold ml-1">{{reservation.attachPromocode}}</span>
                        <span v-if="!getIsLoadingCalculations" class="px-1 bold" >({{getReservationCalculations.attachDiscount.value}}{{(getReservationCalculations.attachDiscount.valueType == 1)? '%' : '€'}})</span>
                    </span>

                    
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.totalDiscounts)}} €</span>
                </div>
            </div>

            <!-- Total in Due -->
            <div class="col-sm-12 bg-darker radius-bottom-right-normal radius-bottom-left-normal areaTotal align-items-center d-flex flex-row ">
                <span v-if="getIsLoadingCalculations"><loader size="big" opacity="0.2"></loader></span>
                <div class="lightest fs-giant font-weight-600 d-flex justify-content-between align-items-center w-100 py-1" v-else-if="reservation.status != '-5'"><!-- -5 == Canceled -->
                    <payment-status-btn :reservation="reservation" />
                    <span v-if="getIsLoadingCalculations"><loader size="big" opacity="0.2"></loader></span>
                    <span v-else-if="totalDue != 0">{{formatPrice(getReservationCalculations.reservationTotalStatus)}}€</span>
                </div>
                <div class="lightest fs-giant font-weight-600 d-flex justify-content-between align-items-center w-100 py-1" v-else-if="reservation.status == '-5'"><!-- -5 == Canceled -->
                    <payment-status-btn :reservation="reservation" />
                    <span v-if="getIsLoadingCalculations"><loader size="big"></loader></span>
                    <span v-else-if="refundTotalMissing != 0 && refundTotalMissing !== undefined">{{formatPrice(getReservationCalculations.totalReceived *-1 )}}€</span>
                </div>
            </div>
        </div>

        <div v-else class="dark text-center m-3 w-100">
            <div class="fs-large darker">Unable to load information</div>
        </div>

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import PaymentStatusBtn from '@/tools/modal/ReservationEditV2/PaymentStatusBtn.vue'
import {mapGetters, mapActions} from 'vuex'
import Loader from '@/tools/loaders/loader1'
export default {
    mixins: [reservationsMixin],
    data: function() {
        return {
            agentCommision: null,
            editingCommission: false,
            editingDiscount: false,
            isCommissionsExpanded: false,
            comissionTypes:[
                {
                    type: 'Product',
                    label: 'Ticket',
                    active: true,
                    editable: true,
                },
                {
                    type: 'Component',
                    label: 'Extras',
                    active: true,
                    editable: true,
                },
                {
                    type: 'Transport',
                    label: 'Transport',
                    active: false,
                    editable: true,
                },
            ],
            isEditingCommissions: {}
        }
    },
    watch: {
        'getReservationCalculations': {
            handler(newVal) {
                this.reservation.currentChannelCommission = newVal.currentChannelCommission;
            },
        }
    },
    created: function() {
        // sets attachDiscount valueType if none
        if (this.reservation.attachDiscount == null) {
            this.$set(this.reservation, 'attachDiscount', {
                value: 0,
                valueType: 0
            })
        }

        this.getSelectedUserComissions();
    },
    computed: {
        ...mapGetters([
            'account',
            'getReservationCalculations',
            'getIsLoadingCalculations',
            'getPaymentState'
        ]),
        cost: function () {
            if (!this.getReservationCalculations) {
                return false;
            } else {
                const cost = this.getReservationCalculations.totalGrossprice - this.getReservationCalculations.totalDiscounts;
                this.getReservationCalculations.cost = cost;
                return cost;
            }
        },
        refundTotalMissing: function () {
            return this.getReservationCalculations.totalActuallyPaid;
        },
        isReservationInvoiced: function () {
            return this.reservation.flags.isFullyInvoiced;
        }
    },
    methods: {
        ...mapActions([
            'setReservationCalculations'
        ]),
        switchDiscountType: function() {
            if (this.reservation.attachDiscount.valueType == 0) {
                this.reservation.attachDiscount.valueType = 1;
            } else {
                this.reservation.attachDiscount.valueType = 0;
            }
            this.updateCalculations();
        },
        switchCommissionType: function(type) {
            if (this.reservation.currentChannelCommission[type.toLowerCase()+'ValueType'] === 0) {
                this.reservation.currentChannelCommission[type.toLowerCase()+'ValueType'] = 1;
            } else {
                this.reservation.currentChannelCommission[type.toLowerCase()+'ValueType'] = 0;
            }
        },
        getSelectedUserComissions: function(){
            if (this.reservation.creatorAgent && this.reservation.creatorAgent.id) {
                axios.get('/api/people/GetAgentCommissions', {
                    params: {
                        supplierId: this.account.supplierId,
                        agentId: this.reservation.creatorAgent.id
                    }
                }).then(response => {
                    if(response.status && response.status == 200){
                        this.setAgentCommision(response.data);
                    }
                })
            }
        },
        setAgentCommision: function(commisions) {
            let agentCommision = commisions.defaultCommision;

            for (let commisionRelation of commisions.commissionRelations) {
                if (commisionRelation.productId == this.reservation.event.product.id) {
                    agentCommision = commisionRelation.commissionValue;
                }
            }

            this.agentCommision = agentCommision;
        },
        cannotChangeInvoicedWarning: function () {
            this.$dialog.alert('<h1>Booking is already invoiced.</h1> <p class="mt-3">You are not allowed to edit comissions or discounts of bookings that have been invoiced. Please check billing details in order to proceed with this.</p>', {okText: 'OK'})
            .then(function () {})
            .catch(function () {});
        },
        updateCommissions: function (commissionType){
            this.$set(this.reservation.updateFlags, 'commissions', true);
            this.$set(this.isEditingCommissions, commissionType.type.toLowerCase(), false);
            this.validateCommissions();
        },
        updateCalculations: function () {
            return this.setReservationCalculations(this.reservation);
        },
        validateCommissions: function () {
            const commission = this.reservation.currentChannelCommission;
            const grandTotal = this.getReservationCalculations.grandTotal;
            let hasError = false;
            
            const validateValue = (value, type, label) => {
                if (type === 0 && value > grandTotal) { // (€)
                    this.$toasted.error(`${label} discount is higher than total, please enter a new value`);
                    hasError = true;
                    return 0;
                }
                if (type === 1 && value > 100) { // (%)
                    this.$toasted.error(`${label} discount is higher than 100%, please enter a new value`);
                    hasError = true;
                    return 0;
                }
                return value;
            };
            
            commission.componentValue = validateValue(commission.componentValue, commission.componentValueType, 'Component');
            commission.productValue = validateValue(commission.productValue, commission.productValueType, 'Product');

            if (!hasError) {
                this.updateCalculations().then(response => {
                    this.reservation.currentChannelCommission = response.data.currentChannelCommission
                });
            }
        },
        editingCommissionToogle: function(type) {
            if (this.isReservationInvoiced) {
                this.cannotChangeInvoicedWarning();
                
                return false;
            }

            this.$set(this.isEditingCommissions, type.toLowerCase(), !this.isEditingCommissions[type.toLowerCase()]);
            this.reservation.currentChannelCommission['isToOverwrite' + type] = true;
        },
        commissionInputFocus: function (type) {
            if (this.reservation.currentChannelCommission[type.toLowerCase()+'Value'] == 0) {
                this.reservation.currentChannelCommission[type.toLowerCase()+'Value'] = null;
            }
        },
        editingDiscountToogle: function() {
            if (this.isReservationInvoiced) {
                this.cannotChangeInvoicedWarning();
                
                return false;
            }

            // if currenly editing this is a remove btn
            if (this.editingDiscount) {
                this.reservation.attachDiscount.value = 0;
                
                this.$set(this.reservation.updateFlags, 'discount', true);
                this.editingDiscount = this.editingDiscount;
                this.updateCalculations();
            }
            
            this.editingDiscount = !this.editingDiscount;
        },
        overrideCommissionChanged: function(e, type) {
            if (e.data == null) {
                this.reservation.currentChannelCommission[type.toLowerCase() + 'Value'] = null;
            }
            
            this.reservation.currentChannelCommission['isToOverwrite' + type] = true;
        },
        discountInputFocus: function () {
            if (this.reservation.attachDiscount.value == 0) {
                this.reservation.attachDiscount.value = null;
            }
        },
        applyingCustomDiscount: function () {
            if (this.reservation.attachDiscount.valueType == 1 && (this.reservation.attachDiscount.value > 100 || this.reservation.attachDiscount.value < 0)) {
                this.$toasted.error('Discount must be between 0 and 100%');
                this.reservation.attachDiscount.value = 0;
                
                return false;
            }

            if (this.reservation.attachDiscount.valueType == 0 && this.reservation.attachDiscount.value < 0) {
                this.$toasted.error('Discount must be higher than 0');
                this.reservation.attachDiscount.value = 0;
                
                return false;
            }

            // set updateFlag or else it will be ignored by API
            this.$set(this.reservation.updateFlags, 'discount', true);
            this.editingDiscount = false;
            this.updateCalculations();
        },
        toggleCommissionExpand: function () {
            this.isCommissionsExpanded = !this.isCommissionsExpanded;
        }
    },
    props: {
        reservation: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Loader,
        PaymentStatusBtn
    }
}
</script>

<style lang="scss" scoped>
    .priceTotalHolder{
        min-height: 180px;
    }

    .areaTotal{
        height: 3.2rem;
    }
</style>



// WEBPACK FOOTER //
// PriceTotal.vue?18bd2381